/* import __COLOCATED_TEMPLATE__ from './lsg-arrow-button.hbs'; */
import { equal } from '@ember/object/computed';
import Component from '@ember/component';

/**
 * The material icons for arrows we support.
 *
 * @type {Object}
 */
export const LSG_ARROW_DIRECTION = {
  LEFT: 'chevron_left',
  RIGHT: 'chevron_right'
};

/**
 * Specify the different styles of the arrow button.
 *
 * @type {Object}
 */
export const LSG_ARROW__STYLE = {
  GRAY: 'gray',
  BLACK: 'black'
};

/**
 * This is a round button like what is used in the new LSG DIY wizard for forward and back buttons
 */
export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'i',
  classNames: ['SH-c-lsg-arrow-button', 'material-icons'],
  classNameBindings: [
    '_isGrayStyle:SH-c-lsg-arrow-button--gray',
    '_isBlackStyle:SH-c-lsg-arrow-button--black',
    'disabled:SH-c-lsg-arrow-button--disabled',
  ],

  /**
   * The overall button style including hover functionality.
   *
   * @param {String}    Of type LSG_ARROW__STYLE.*
   */
  buttonStyle: LSG_ARROW__STYLE.GRAY,

  /**
   * @param {String}    Of type LSG_ARROW_DIRECTION.*
   */
  direction: LSG_ARROW_DIRECTION.LEFT,

  /**
   * @param {boolean}
   */
  disabled: false,

  /**
   * Different booleans for the button style for classNameBindings
   *
   * @type {Boolean}
   */
  _isGrayStyle: equal('buttonStyle', LSG_ARROW__STYLE.GRAY),
  _isBlackStyle: equal('buttonStyle', LSG_ARROW__STYLE.BLACK),
});
